<mat-dialog-content>
    <h1 class="text-black text-2xl mb-4">Agregar Contacto</h1>
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
        <div class="flex flex-col mb-4">
            <label for="clientCode" class="text-gray-700">Código de Cliente</label>
            <input id="clientCode" matInput type="number" formControlName="clientCode"
                placeholder="Ingrese el código de cliente"
                class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
            <mat-error
                *ngIf="contactForm.get('clientCode')?.hasError('required') && contactForm.get('clientCode')?.touched">
                El código de cliente es requerido
            </mat-error>
        </div>
        <div class="flex flex-col mb-4">
            <label for="familyId" class="text-gray-700">ID de Familia</label>
            <input id="familyId" matInput type="number" formControlName="familyId"
                placeholder="Ingrese el ID de familia"
                class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
            <mat-error
                *ngIf="contactForm.get('familyId')?.hasError('required') && contactForm.get('familyId')?.touched">
                El ID de familia es requerido
            </mat-error>
        </div>
        <div class="flex flex-col mb-4">
            <label for="email" class="text-gray-700">Email</label>
            <input id="email" matInput type="email" formControlName="email" placeholder="Ingrese su email"
                class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
            <mat-error *ngIf="contactForm.get('email')?.hasError('required') && contactForm.get('email')?.touched">
                El email es requerido
            </mat-error>
        </div>
        <div class="flex flex-col mb-4">
            <label for="state" class="text-gray-700">Estado</label>
            <input id="state" matInput type="text" formControlName="state" placeholder="Ingrese el estado"
                class="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-blue-500">
            <mat-error *ngIf="contactForm.get('state')?.hasError('required') && contactForm.get('state')?.touched">
                El estado es requerido
            </mat-error>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="justify-between">
    <button class="bg-orange-400 hover:bg-orange-500 text-white font-bold py-2 px-4 mb-3 rounded" mat-button
        type="submit" [disabled]="!contactForm.valid" (click)="onSubmit()">Agregar Contacto</button>
    <button class="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 mb-3 ml-5 rounded" mat-button
        (click)="closeModal()">Cancelar</button>
</mat-dialog-actions>